export default __webpack_public_path__ + "static/media/011-shotgun.e8977f0a.png";